<template>
    <GekkoButton 
        @click="changeBillingUrl()"
        :text="$gettext('Upgrade')"
        icon="fa-solid fa-shopping-cart"
    />
</template>

<script>
import GekkoButton from "@/components/GekkoButton";

export default {
    name: "ActionButtonUpgrade",
    components: {GekkoButton},
    methods: {
        changeBillingUrl() {
            this.$router.push({name: "UpgradeSubscription"});
        }
    }
}
</script>
